<template>
  <div>
    <RevTextList variant="ordered">
      <template #default>
        <RevTextListItem class="flex">
          <div>
            {{ i18n(translations.printSetp) }}
          </div>
        </RevTextListItem>

        <RevTextListItem class="flex">
          <div class="flex flex-col space-y-16">
            <span>
              {{ i18n(translations.packingStepContent1) }}
            </span>

            <span>
              {{ i18n(translations.packingStepContent2) }}
            </span>
          </div>
        </RevTextListItem>

        <RevTextListItem class="flex">
          <div>
            {{ i18n(translations.stickStep) }}
          </div>
        </RevTextListItem>

        <RevTextListItem class="flex">
          <div class="flex flex-col space-y-8">
            {{ i18n(translations.sendStep, { date: i18n.date(expiryDate) }) }}

            <RevLink
              class="mt-8"
              target="_blank"
              :to="productReturnFaqArticleLink"
            >
              {{ i18n(translations.sendStepCta) }}
            </RevLink>
          </div>
        </RevTextListItem>

        <RevTextListItem class="flex">
          <div>
            {{ i18n(translations.jobDoneStep) }}
          </div>
        </RevTextListItem>
      </template>
    </RevTextList>
  </div>
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#imports'

import { useIntercomHelpCenterBaseUrl } from '@backmarket/nuxt-layer-base/composables/useIntercomHelpCenterBaseUrl'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { RevLink } from '@ds/components/Link'
import { RevTextList } from '@ds/components/TextList'
import { RevTextListItem } from '@ds/components/TextListItem'

import { isConfigDefined } from '~/scopes/care-commons/utils/isConfigDefined'

import translations from './ReturnSteps.translations'
import type { ReturnStepsProps } from './ReturnSteps.types'

const { expiryDate } = defineProps<ReturnStepsProps>()

const i18n = useI18n()

const { INTERCOM_HELP_CENTER_ARTICLE_RETURN_FAQ } = useRuntimeConfig().public
const { intercomHelpCenterBaseUrl } = useIntercomHelpCenterBaseUrl()

const productReturnFaqArticleLink = toNuxtLink({
  type: 'external',
  href: `${intercomHelpCenterBaseUrl}articles/${isConfigDefined(INTERCOM_HELP_CENTER_ARTICLE_RETURN_FAQ, 'INTERCOM_HELP_CENTER_ARTICLE_RETURN_FAQ')}`,
})
</script>
